import { render, staticRenderFns } from "./BadgePreview.vue?vue&type=template&id=0b2435ce&scoped=true"
import script from "./BadgePreview.vue?vue&type=script&lang=js"
export * from "./BadgePreview.vue?vue&type=script&lang=js"
import style0 from "./BadgePreview.vue?vue&type=style&index=0&id=0b2435ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2435ce",
  null
  
)

export default component.exports